/**
 * Client-side mirror of backend services/contact_filter.py.
 *
 * This is UX only — it disables the Send button before the user submits.
 * The server ALWAYS re-runs the same rules and is the source of truth.
 * Never rely on the client check alone.
 */

const PHONE_PATTERNS = [
  // +91 with optional separator
  /\+?\s*91[\s\-.]?\d{10}/,
  // Hyphenated groups
  /\b\d{4}[\s\-.]\d{3}[\s\-.]\d{3}\b/,
  /\b\d{5}[\s\-.]\d{5}\b/,
  // Bare 10-digit run
  /\b\d{10}\b/,
  // Spaced/broken digits
  /(?:\d[\s\-.]){9}\d/,
];

const EMAIL_PATTERN = /[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}/;

const WHATSAPP_TOKENS = [
  "whatsapp",
  "whats app",
  "whatsap",
  "wtsp",
  "w app",
  "wa.me",
  "chat.whatsapp.com",
];

const CONTACT_PHRASE_TOKENS = [
  "telegram",
  "signal app",
  "dm me on",
  "message me on",
  "text me on",
  "call me on",
  "my number is",
  "insta id",
  "instagram id",
  "email me at",
  "gmail.com",
  "@gmail",
];

const HOMOGLYPHS = { O: "0", o: "0", l: "1", I: "1", "|": "1" };

const normalise = (text) => {
  if (!text) return "";
  // Fold full-width chars to ASCII.
  let out = text.normalize("NFKC");
  // Strip zero-width and other format chars.
  out = out.replace(/[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g, "");
  // Collapse whitespace.
  out = out.replace(/\s+/g, " ").trim();
  return out;
};

const applyHomoglyphs = (text) =>
  text.replace(/[OolI|]/g, (ch) => HOMOGLYPHS[ch] ?? ch);

export const MESSAGES = {
  phone:
    "Phone numbers cannot be shared here. Bookings stay on FitFrik for your protection.",
  whatsapp:
    "Contact details cannot be shared here. Bookings stay on FitFrik for your protection.",
  contact_phrase:
    "Contact details cannot be shared here. Bookings stay on FitFrik for your protection.",
  email:
    "Contact details cannot be shared here. Bookings stay on FitFrik for your protection.",
};

/**
 * Returns the name of the matching rule, or null.
 * @param {string} text
 * @returns {"phone" | "whatsapp" | "contact_phrase" | "email" | null}
 */
export function detectContactLeak(text) {
  if (!text) return null;
  const normalised = normalise(text);
  const lowered = normalised.toLowerCase();
  const phoneProbe = applyHomoglyphs(lowered);

  for (const pat of PHONE_PATTERNS) {
    if (pat.test(phoneProbe)) return "phone";
  }
  for (const t of WHATSAPP_TOKENS) {
    if (lowered.includes(t)) return "whatsapp";
  }
  for (const t of CONTACT_PHRASE_TOKENS) {
    if (lowered.includes(t)) return "contact_phrase";
  }
  if (EMAIL_PATTERN.test(normalised)) return "email";
  return null;
}

export default detectContactLeak;
